'use client';

import { c as _c } from "react/compiler-runtime";
import { FOCUS_RING } from '@common/components/interaction';
import SvgFireFill from '@common/icon/SvgFireFill';
import { cn } from '@core/utils';
import { CustomLink } from '@/app/_components/CustomLink';
import { readTappedThumbnail, rememberGiftPreview } from '@/app/_components/GiftCard/giftPreview';
import { Image } from '@/components/client';
import { Rating } from '@/components/molecule/Rating';
import { BREAKPOINTS, DONATION_ROUTES } from '@/constants';
import { getTimeAgo } from '../../RecentOrderGiftsSection/RecentOrderGiftListItem';
import type { RecentOrderGiftItem } from '../../RecentOrderGiftsSection/RecentOrderGiftsSection';
interface LiveDonationItemProps {
  item: RecentOrderGiftItem;
  priority?: boolean;
}
export const LiveDonationItem = t0 => {
  const $ = _c(39);
  const {
    item: t1,
    priority
  } = t0;
  const {
    mainImageUrl,
    institutionName,
    productNumber,
    productSlugId,
    productName,
    reviewCount,
    reviewRating,
    createAt
  } = t1;
  const detailProductNumber = productSlugId ?? productNumber;
  let t2;
  if ($[0] !== detailProductNumber) {
    t2 = DONATION_ROUTES.GIFTS_DETAIL.pathname({
      productNumber: detailProductNumber
    });
    $[0] = detailProductNumber;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `${productName} 상세 페이지로 이동`;
  let t4;
  if ($[2] !== detailProductNumber || $[3] !== institutionName || $[4] !== mainImageUrl || $[5] !== productName) {
    t4 = event => {
      rememberGiftPreview({
        productNumber: detailProductNumber,
        mainImageUrl,
        thumbnailSrc: readTappedThumbnail(event.currentTarget),
        productName,
        institutionName
      });
    };
    $[2] = detailProductNumber;
    $[3] = institutionName;
    $[4] = mainImageUrl;
    $[5] = productName;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = cn("group flex w-[22rem] items-center gap-20 rounded-xlarge", "mobile-tablet:h-96 mobile-tablet:w-full mobile-tablet:gap-12 mobile-tablet:rounded-small", FOCUS_RING);
    t6 = cn("relative size-140 shrink-0 overflow-hidden rounded-xlarge border border-Gray-black/5 bg-Gray-black/5", "transition-opacity duration-200 ease-out group-hover:opacity-80 group-active:opacity-80 motion-reduce:transition-none", "mobile-tablet:size-76 mobile-tablet:rounded-small");
    $[7] = t5;
    $[8] = t6;
  } else {
    t5 = $[7];
    t6 = $[8];
  }
  let t7;
  if ($[9] !== mainImageUrl || $[10] !== priority) {
    t7 = <div className={t6}><Image src={mainImageUrl} alt="" width={280} height={280} preload={priority} sizes={`${BREAKPOINTS.MOBILE_TABLET} 76px, 140px`} className="size-full object-cover" /></div>;
    $[9] = mainImageUrl;
    $[10] = priority;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = cn("truncate font-600 tracking-[-0.02em] text-Gray-600 typo-body4", "mobile-tablet:typo-caption1");
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== institutionName) {
    t9 = <p className={t8}>{institutionName}</p>;
    $[13] = institutionName;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = cn("line-clamp-2 min-h-[2lh] font-500 leading-[1.3] text-Gray-800 typo-body3", "mobile-tablet:line-clamp-1 mobile-tablet:min-h-0 mobile-tablet:text-[15px]");
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== productName) {
    t11 = <p className={t10}>{productName}</p>;
    $[16] = productName;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== reviewCount || $[19] !== reviewRating) {
    t12 = reviewCount > 0 ? <div className="flex items-center gap-4"><Rating value={reviewRating} size={16} starCount={1} /><span className="font-400 text-Gray-600 typo-caption1">{reviewRating.toFixed(1)} ({reviewCount.toLocaleString()})</span></div> : null;
    $[18] = reviewCount;
    $[19] = reviewRating;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t11 || $[22] !== t12 || $[23] !== t9) {
    t13 = <div className="flex flex-col gap-4">{t9}{t11}{t12}</div>;
    $[21] = t11;
    $[22] = t12;
    $[23] = t9;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <SvgFireFill aria-hidden="true" className="size-20 shrink-0 text-O-300" />;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== createAt) {
    t15 = getTimeAgo(createAt);
    $[26] = createAt;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== t15) {
    t16 = <p className="flex items-center font-600 text-O-400 typo-body2 mobile-tablet:typo-body4">{t14}<span className="truncate">{t15} 전에 기부했어요!</span></p>;
    $[28] = t15;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== t13 || $[31] !== t16) {
    t17 = <div className="flex min-w-0 flex-1 flex-col gap-8 mobile-tablet:gap-4">{t13}{t16}</div>;
    $[30] = t13;
    $[31] = t16;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== t17 || $[34] !== t2 || $[35] !== t3 || $[36] !== t4 || $[37] !== t7) {
    t18 = <li><CustomLink href={t2} aria-label={t3} onClick={t4} className={t5}>{t7}{t17}</CustomLink></li>;
    $[33] = t17;
    $[34] = t2;
    $[35] = t3;
    $[36] = t4;
    $[37] = t7;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  return t18;
};